<template>
  <div>
    <custom-callout has-gradient :has-toggle="false">
      <section class="row w-100 py-3">
        <div class="col-12 col-md-11">
          <div class="row">
            <div class="col-md-3">
              <CustomInputDisplay
                label="Tipo de SAEE:"
                label-class="text-gray font-weight-light"
                :value="item.type"
                class="font-weight-bold pl-3"
              />
            </div>
            <div class="col-md-3">
              <CustomInputDisplay
                label="Actividad:"
                label-class="text-gray font-weight-light"
                :value="item.activity"
                class="font-weight-bold pl-3"
              />
            </div>
            <div class="col-md-3">
              <CustomInputDisplay
                label="Fecha de la actividad:"
                label-class="text-gray font-weight-light"
                :value="dateFormat"
                class="font-weight-bold pl-3"
              />
            </div>
            <div class="col-md-3">
              <CustomInputDisplay
                label="Dirigido a:"
                label-class="text-gray font-weight-light"
                :value="addressedTo"
                class="font-weight-bold pl-3"
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md">
              <CustomInputDisplay
                label="Descripción de la actividad:"
                label-class="text-gray font-weight-light"
                :value="item.description"
                class="font-weight-bold pl-3"
              />
            </div>
          </div>
        </div>
        <div class="col-12 col-md-1 d-flex justify-content-end">
          <DropDown
            class="actions-dropdown pt-2 pr-4"
            :items="getMenuItems"
            normal-size
            :always-show-dropdown="true"
          />
        </div>
      </section>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from "custom-callout";
import CustomInputDisplay from "CustomInputDisplay";
import DropDown from "dropdown";
import moment from "moment";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";
import transitionStudentService from "@/services/pei/transitionStudent.js";

const ROUTE_NAME_ADD_ACTIVITY = "transition-student-12b";

export default {
  components: {
    CustomCallout,
    CustomInputDisplay,
    DropDown
  },
  mixins: [alertMixin],
  props: {
    item: {
      type: Object
    },
    search: {
      type: Function,
      default: () => undefined
    },
    academicYearId: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },
    activeIndex: {
      type: Number,
      default: null
    }
  },
  computed: {
    addressedTo() {
      return this.item.isIndividual ? "Estudiante" : "Grupo";
    },
    dateFormat() {
      return moment(this.item.date)
        .locale("es")
        .format("DD/MMM/YYYY");
    },
    getMenuItems() {
      let result = [
        {
          label: "Entrar",
          icon: "fas fa-file-import text-green",
          click: () => this.handlerGoTo()
        }
      ];
      if (
        1 == 1 //se cambiara por el permiso en la US correspondiente
      ) {
        result.push({
          label: `Cancelar`,
          icon: "fas fa-times-circle text-red",
          class: "border-top",
          click: () => this.handlerCancel()
        });
      }

      return result;
    }
  },
  methods: {
    handlerGoTo() {
      this.$router.push({
        name: ROUTE_NAME_ADD_ACTIVITY,
        params: {
          id: this.item.id,
          academicYearId: this.academicYearId
        }
      });
    },
    async handlerCancel() {
      let answer = await this.ShowCancelModal(
        "Atención",
        "¿Está seguro que desea proceder con la cancelación de la  SAEE-12b?",
        "Sí",
        "No"
      );
      if (answer) {
        transitionStudentService
          .cancelSAEE12b({ id: this.item.id })
          .then(() => {
            this.$emit("refreshSearchResults");
          })
          .catch(err => {
            this.ShowToast(
              "Alerta",
              "Ha ocurrido un error inesperado.",
              "error"
            );
          });
      }
    }
  }
};
</script>

<style scope></style>
